export default ({ request }) => ({
  evgExpenseItemListApi(data = {}) {
    return request({
      url: '/financial/evg/expense/item/list',
      method: 'POST',
      data,
    })
  },
})
